module.exports = __webpack_public_path__ + "static/media/carboncraft.c9103789.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/carboncraft.webp
// module id = 227
// module chunks = 0